import React, { Component } from 'react'
import moment from 'moment'
import { withRouter } from 'react-router-dom'
import { DragDropContext } from 'react-beautiful-dnd'
import { connect } from "react-redux"
import * as actions from "../../actions/actions"
import '../../sass/monthlyResource/_month-resource-page.scss'

// Components
import Calendar from './parts/MonthlyResourceCalendar/MonthlyResourcesCalendar'
import UpdateProccessPopup from '../updatePopups/UpdateProccessPopup'
import OnDragPopup from '../updatePopups/OnDragPopup'
import SpreadingPopup from '../updatePopups/SpreadingPopup'
import ConstantPopup from '../updatePopups/ConstantPopup'
import LoaderNew from '../../components/LoaderNew/Loader'

// Functions
import MonthyResourceTools from './tools'
import { montlyUpdateOrders, montlyUpdateOrdersForConst, updateProcess, getWarnings, setEndDateForProcess } from '../../functions/api/orders'
import { removeFractionsOnBacklogDrag, removeBacklogDuplications } from './MonthlyResourcesView'
import { isSameDay } from '../../functions/general/general'
import { generalGetRequest } from '../../functions/api/general'
import { segmentProcesses } from "./parts/MonthlyResourceCalendar/processSegmentation"
import { isWeekChange, closePopupOnBackButton, dateMatch } from '../../hooks/helper'

// Constants
import { PER_USER, VIEW_ONLY, DEPARTMENT_ONLY } from '../../tools/keys/variables'
import * as momentBusinessDays from 'moment-business-days'
import jwt_decode from "jwt-decode"

momentBusinessDays.updateLocale('us', {
    workingWeekdays: [0, 1, 2, 3, 4]
})

class MonthlyResourceView extends Component {
    constructor() {
        super()

        this.state = {
            orders: [],
            currentDate: moment().startOf("week"),
            datesArray: [],
            prevState: [],
            popup: false,
            updateApiBody: null,
            errPopupState: null,
            updateProcessPopup: false,
            spreadingPopup: false,
            selectedProcess: {},
            warnings: [],
            loader: false,
            spreadingBodyData: {},
            constant_spred: false,
            simpleDateArray: [],
            z_index: [],
            end_dateChanged: false,
            spreading: false
        }

        this.initProccessUpdatePopup = this.initProccessUpdatePopup.bind(this)
        this.checkIfSameDay = this.checkIfSameDay.bind(this)
        this.buildDatesArray = this.buildDatesArray.bind(this)
        this.fourWeeksDateChange = this.fourWeeksDateChange.bind(this)
        this.backToToday = this.backToToday.bind(this)
        this.spreadingFalse = this.spreadingFalse.bind(this)
        this.spreadingTrue = this.spreadingTrue.bind(this)
        this.cancleSpreading = this.cancleSpreading.bind(this)
        this.handlePopupChoice = this.handlePopupChoice.bind(this)
        this.closeUpdateMenu = this.closeUpdateMenu.bind(this)
        this.submitUpdatesFromPopup = this.submitUpdatesFromPopup.bind(this)
        this.saveNewSelectedProcess = this.saveNewSelectedProcess.bind(this)
        this.deleteBacklogsDuplications = this.deleteBacklogsDuplications.bind(this)
        this.updateConstantToSpred = this.updateConstantToSpred.bind(this)
        this.onDragEnd = this.onDragEnd.bind(this)
        this.onBeforeCapture = this.onBeforeCapture.bind(this)
    }

    componentDidMount() {
        window.onpopstate = () => closePopupOnBackButton(this.state.updateProcessPopup, (data) => {
            data && this.closeUpdateMenu()
        })

        let pathname = window.location.pathname
        this.props.setRouteLocation(pathname)

        const dynamicFactoryName = this.props.login.user.factory_name
        let initDate = this.props.match.params.date

        if (!initDate) {
            let searchQuery = window.location.search
            this.props.history.push(`/${dynamicFactoryName}/monthly-resources/${this.state.currentDate}${searchQuery || ''}`)
            this.initializeData()
        } else {
            this.setState({
                currentDate: moment(initDate).startOf("week"),
            }, () => this.initializeData())
        }
    }

    componentDidUpdate(prevProps) {
        const shouldRefetch =
            this.props.process.show_bids !== prevProps.process.show_bids ||
            prevProps.location.search !== this.props.location.search ||
            JSON.stringify(prevProps.login.selectedDepartment) !== JSON.stringify(this.props.login.selectedDepartment) ||
            JSON.stringify(prevProps.login.selectedManager) !== JSON.stringify(this.props.login.selectedManager) ||
            prevProps.login.selectedUser !== this.props.login.selectedUser

        const orderEdited =
            prevProps.mainPopup.eddited_order_id !== this.props.mainPopup.eddited_order_id &&
            this.props.mainPopup.eddited_order_id

        if (orderEdited) {
            this.repositionConstantAfterEditInPopup(this.props.mainPopup)
        }

        const newOrderAdded =
            this.props.login.lastAddedOrderId &&
            prevProps.login.lastAddedOrderId !== this.props.login.lastAddedOrderId

        if (newOrderAdded || shouldRefetch) {
            this.initializeData()
        }
    }

    componentWillUnmount() {
        window.onpopstate = null
    }

    repositionConstantAfterEditInPopup = async (information) => {
        if (isSameDay(new Date(information.order_data.due_date), new Date(information.new_due_date_after_edit_from_reservation_popup))) {
            return
        }

        this.props.updateConstantPopup(true)

        let res = await generalGetRequest(`/system/order-process/get-last-order-process?order_id=${information.order_id}`)
        let selectedProcess = {
            _id: res.result._id,
            order_number: information.order_data.order_number,
            order_id: information.order_id,
            due_date: new Date(information.order_data.due_date),
            date: new Date(information.new_due_date_after_edit_from_reservation_popup),
            client_name: information.order_data.client_name,
            warnings: [],
            process: res.result,
        }

        this.setState({
            updateApiBody: selectedProcess,
            spreadingBodyData: selectedProcess
        })
    }

    updateConstantToSpred(boolean) {
        this.setState({ constant_spred: boolean })
    }

    deleteBacklogsDuplications(process) {
        let newState = removeBacklogDuplications(process, this.state.datesArray)
        this.setTransformDatesArray(newState)
    }

    initializeData = async () => {
        if (!this.state.spreadingPopup) {
            this.setState({ loader: true })
        }

        let from = this.state.currentDate._d
        let to = moment(this.state.currentDate).add(28, 'days')._d

        const search = window.location.search
        const params = new URLSearchParams(search)
        const urlOrderNumber = params.get('order_number') || '';
        const all_results = params.get("all_results") || false;

        let selectedDepartment = this.props.login.selectedDepartment._id
        let employee_id = this.props.login.selectedManager._id || ''
        const user_id = jwt_decode(this.props.login.user.token)._id
        const selectedUser = this.props.login.user.privileges.includes(PER_USER) ? user_id : this.props.login.selectedUser

        const promises = []
        promises.push(this.getOrderProcesses(
            moment(from).toISOString(),
            moment(to).toISOString(),
            selectedUser,
            employee_id,
            selectedDepartment,
            urlOrderNumber || '',
            all_results
        ))

        const totalResponse = []
        const responses = await Promise.all(promises)
        for (const response of responses) {
            if (response.ok) {
                totalResponse.push(...response.result)
            }
        }

        this.setState({ orders: totalResponse }, () => {
            let oldDatesArray = this.buildDatesArray(this.state.currentDate)
            const datesArray = segmentProcesses(oldDatesArray)
            this.setState({ datesArray, loader: false }, () => this.prepareSimpleDateArray())
        })

        let addOrderApiPayload = {
            from,
            to,
            view: 'L',
            department_id: this.props.login.selectedDepartment?._id || null
        }
        this.props.setAddOrderPayload(addOrderApiPayload)
    }

    refreshSingleOrder = async (orderNumber) => {
        const { currentDate, datesArray } = this.state

        const selectedDepartment = this.props.login.selectedDepartment._id
        const employee_id = this.props.login.selectedManager._id || ''
        const user_id = jwt_decode(this.props.login.user.token)._id
        const selectedUser = this.props.login.user.privileges.includes(PER_USER)
            ? user_id
            : this.props.login.selectedUser

        const from = moment(currentDate).toISOString()
        const to = moment(currentDate).add(28, 'days').toISOString()

        const search = window.location.search
        const params = new URLSearchParams(search)
        const urlOrderNumber = orderNumber || params.get('order_number') || '';
        const all_results = params.get("all_results") || false;

        this.setState({ loader: true })

        const response = await this.getOrderProcesses(
            moment(from).toISOString(),
            moment(to).toISOString(),
            selectedUser,
            employee_id,
            selectedDepartment,
            urlOrderNumber || '',
            all_results
        )

        if (!response.ok) {
            this.setState({ loader: false })
            return
        }

        const freshDayBuckets = response.result

        const freshByDate = {}
        freshDayBuckets.forEach(bucket => {
            const parsed = moment(bucket.date).format('DD/MM/YYYY')
            freshByDate[parsed] = bucket.dayData || []
        })

        const updatedDatesArray = datesArray.map(day => {
            const filteredDayData = day.dayData.map(userSlot => ({
                ...userSlot,
                value: userSlot.value.filter(
                    p => String(p.order_number) !== String(orderNumber)
                )
            }))

            const incoming = freshByDate[day.parsedDate] || []
            const mergedDayData = filteredDayData.map(userSlot => {
                const freshForUser = incoming
                    .filter(inc => inc.key === userSlot.key)
                    .flatMap(inc => inc.value || [])

                return freshForUser.length
                    ? { ...userSlot, value: [...userSlot.value, ...freshForUser] }
                    : userSlot
            })

            return { ...day, dayData: mergedDayData }
        })

        const segmented = segmentProcesses(updatedDatesArray)
        this.setState({ datesArray: segmented, loader: false }, () => this.prepareSimpleDateArray())
    }

    getOrderProcesses = async (startDate, to, selectedUser, employee_id, selectedDepartment, order_number, all_results) => {
        const isFiltered = !!(selectedUser || selectedDepartment)
        const callFrom = 'monthly'
        const response = await generalGetRequest(`/system/order/vertical-daily-view?start_date=${startDate}&end_date=${to}&user_id=${selectedUser}&order_employee_id=${employee_id}&department_id=${selectedDepartment}&order_number=${order_number}&call=${callFrom}&all_results=${all_results}`)
        return response
    }

    fourWeeksDateChange(operator) {
        this.setState({ orders: [], loader: true }, () => {
            const days = operator === 'inc' ? 28 : -28
            this.setState(prevState => ({
                currentDate: moment(prevState.currentDate).add(days, 'day'),
                loader: true
            }), () => {
                const dynamicFactoryName = this.props.login.user.factory_name
                let searchQuery = window.location.search
                this.props.history.push(`/${dynamicFactoryName}/monthly-resources/${this.state.currentDate}${searchQuery || ''}`)
                this.initializeData()
            })
        })
    }

    buildDatesArray(date) {
        let holidayDatesArray = this.props.login.user.holidays.map(item => moment(item.date).format('DD/MM/YYYY'))
        let daysOffArray = this.props.login.user.off_days
        let newDateDataArray = []
        let newDateDataArray1 = []
        let weekDays = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת']

        for (let i = 0; i < 28; i++) {
            if ([5, 12, 19, 26].includes(i)) {
                newDateDataArray1 = []
            }

            let incrementedDate = moment(date).add(i, 'days')
            let holidayIndex = -1
            let holidayDate = ""
            let dayOff = false

            for (let j = 0; j < holidayDatesArray.length; j++) {
                if (holidayDatesArray[j] === incrementedDate.format('DD/MM/YYYY')) {
                    holidayIndex = j
                    holidayDate = this.props.login.user.holidays[holidayIndex]
                }
            }

            for (let j = 0; j < daysOffArray.length; j++) {
                if (daysOffArray[j] === incrementedDate.day()) {
                    dayOff = true
                }
            }

            newDateDataArray1.push({
                date: JSON.parse(JSON.stringify(incrementedDate._d)),
                parsedDate: incrementedDate.format('DD/MM/YYYY'),
                isoDate: moment(incrementedDate._d).toISOString(),
                isProcessBlank: this.filterBlankProcess(incrementedDate._d),
                dateName: weekDays[incrementedDate.day()] || incrementedDate.format('dddd'),
                holiday: holidayIndex !== -1 ? this.props.login.user.holidays[holidayIndex] : null,
                dayOff,
                dayData: this.filterData(incrementedDate._d)
            })

            if ([4, 11, 18, 25].includes(i)) {
                newDateDataArray = [...newDateDataArray, ...newDateDataArray1]
            }
        }

        return newDateDataArray
    }

    filterData = (date) => {
        let temp = []
        this.state.orders.forEach(item => {
            if (this.checkIfSameDay(item.date, date)) {
                temp = item.dayData
            }
        })
        return temp
    }

    filterBlankProcess = (date) => {
        let temp = false
        this.state.orders.forEach(item => {
            if (this.checkIfSameDay(item.date, date)) {
                temp = item.isProcessBlank
            }
        })
        return temp
    }

    prepareSimpleDateArray = () => {
        if (this.state.datesArray.length > 0) {
            let _simple_date_Array = []
            this.state.datesArray.forEach(day => {
                if (!day.dayOff && !_simple_date_Array.includes(day.parsedDate)) {
                    _simple_date_Array.push(day.parsedDate)
                }
            })
            const _z_index = this.findHoliday(_simple_date_Array)
            this.setState({
                simpleDateArray: _simple_date_Array,
                z_index: _z_index
            })
        } else {
            this.setState({
                simpleDateArray: [],
                z_index: []
            })
        }
    }

    setTransformDatesArray = (oldDatesArray) => {
        const next = segmentProcesses(oldDatesArray)

        if (next === this.state.datesArray) return

        this.setState({ datesArray: next })
    }

    findHoliday = (simple_date) => {
        const { holidays } = this.props.login.user
        let year = new Date(this.state.currentDate._d).getFullYear()
        let month = new Date(this.state.currentDate._d).getMonth()

        const holidayArray = holidays
            .filter(item => {
                const itemDate = new Date(item.date)
                return itemDate.getFullYear() === year && itemDate.getMonth() === month
            })
            .map(item => moment(item.date).format('DD/MM/YYYY'))

        const z_index = []
        simple_date.forEach((item, index) => {
            if (index % 5 === 0) {
                if (holidayArray.includes(item)) {
                    let increase = 0
                    for (let i = index; i <= index + 4; i++) {
                        if (!holidayArray.includes(simple_date[i])) {
                            z_index.push(index + increase)
                            return
                        }
                        increase++
                    }
                } else {
                    z_index.push(index)
                }
            }
        })
        return z_index
    }

    checkIfSameDay(d1, d2) {
        let dateOne = new Date(d1)
        let dateTwo = new Date(d2)
        return dateOne.getFullYear() === dateTwo.getFullYear() &&
            dateOne.getMonth() === dateTwo.getMonth() &&
            dateOne.getDate() === dateTwo.getDate()
    }

    handlePopupChoice = async (param, constantData = false) => {
        if (param !== 'yes') {
            const prevState =
                this.state.prevState?.length
                    ? structuredClone(this.state.prevState)
                    : structuredClone(this.state.datesArray);

            this.setState({
                popup: false,
                errPopupState: null,
                loader: false,
                spreading: false
            });

            this.setTransformDatesArray(prevState);
            return;
        }

        const { constant_spred, end_dateChanged, spreading } = this.state;
        const updateApiBody = structuredClone(this.state.updateApiBody);
        const spreadBody = this.state.spreadingBodyData || {};

        const updatedProcess = {
            ...updateApiBody.process,
            ...(spreadBody.resources_added && { resources_added: spreadBody.resources_added }),
            ...(spreadBody.resources_removed && { resources_removed: spreadBody.resources_removed })
        };

        updateApiBody.process = updatedProcess;

        this.setState({
            popup: false,
            spreadingPopup: false,
            loader: true,
            updateApiBody
        });

        if (updateApiBody.toBacklog) {
            const res = await updateProcess(updatedProcess);
            if (res.ok) {
                const datesArray = removeFractionsOnBacklogDrag(
                    updatedProcess,
                    this.state.datesArray
                );
                this.setTransformDatesArray(datesArray);
            }
            this.setState({ loader: false });
            return;
        }

        const body = {
            ...updateApiBody,
            ...(constantData && {
                reason: constantData.reason.value,
                approved_by: constantData.approveName.value
            })
        };

        const isSameDate =
            (dateMatch(new Date(updatedProcess.process_date)) ===
            dateMatch(new Date(updateApiBody.date))) && (dateMatch(new Date(updatedProcess.process_endDate)) ===
            dateMatch(new Date(updateApiBody.endDate)));

        let res;

        if (updatedProcess.constant && !constant_spred) {
            if (!isSameDate) {
                res = await montlyUpdateOrdersForConst(
                    body,
                    this.props.login.selectedDepartment._id
                );
            }
        } else {
            await updateProcess(updatedProcess);
            if (!isSameDate) {
                res = await montlyUpdateOrders(
                    body,
                    spreading,
                    this.props.login.selectedDepartment._id
                );
            }
            this.updateConstantToSpred(false);
        }

        if (end_dateChanged && res?.result?._id) {
            const endDateBody = {
                _id: res.result._id,
                date: updateApiBody.endDate,
                order_process_end_date: updateApiBody.order_process_end_date,
                order_process_start_date: updateApiBody.order_process_start_date,
                view: updateApiBody.view,
                from: updateApiBody.from,
                to: updateApiBody.to,
                department_id: this.props.login.selectedDepartment._id,
                order_id: updateApiBody.order_id,
            };

            const res2 = await setEndDateForProcess(endDateBody, spreading);
            if (!res2.ok) {
                this.setState({ errPopupState: res2.result, popup: true });
            }
            this.setState({ end_dateChanged: false });
        }

        if (res && !res.ok) {
            this.setState({
                errPopupState: res.result,
                popup: true,
                loader: false
            });
            return;
        }

        this.setState({ spreading: false, orders: [] });
        const movedOrderNumber = updateApiBody.order_number;
        this.refreshSingleOrder(movedOrderNumber);
    };

    onDragEnd({ source, destination, draggableId }) {
        if (!destination) return;

        const processId = draggableId.split('_')[0];
        this.updateOpacity(1, processId);

        const [srcDate, srcResource] = source.droppableId.split('_');
        const [dstDate, dstResource] = destination.droppableId.split('_');

        if (
            srcDate === dstDate &&
            srcResource === dstResource &&
            source.index === destination.index
        ) {
            return;
        }

        const privileges = this.props.login.user.privileges;
        if (privileges.includes(DEPARTMENT_ONLY)) return;

        const getCol = d => Number(d.split('-')[1]);
        if (
            getCol(dstDate) > getCol(srcDate) &&
            privileges.includes(VIEW_ONLY)
        ) return;

        this.setState({ loader: true });

        const datesArrayCopy = structuredClone(this.state.datesArray);

        const srcDayIdx = datesArrayCopy.findIndex(d => d.parsedDate === srcDate);
        const dstDayIdx = datesArrayCopy.findIndex(d => d.parsedDate === dstDate);
        if (srcDayIdx === -1 || dstDayIdx === -1) return;

        let process, srcUserIdx, srcValIdx;

        datesArrayCopy[srcDayIdx].dayData.some((u, uIdx) => {
            const vIdx = u.value.findIndex(p => p.proccess._id === processId);
            if (vIdx !== -1) {
                process = u.value[vIdx];
                srcUserIdx = uIdx;
                srcValIdx = vIdx;
                return true;
            }
            return false;
        });

        if (!process) {
            this.setState({ loader: false });
            return;
        }

        datesArrayCopy[srcDayIdx].dayData[srcUserIdx].value.splice(srcValIdx, 1);
        datesArrayCopy[dstDayIdx].dayData[srcUserIdx].value.splice(
            destination.index,
            0,
            process
        );

        const destinationDate = moment(dstDate, 'DD-MM-YYYY').toDate();
        const diffDays = moment(destinationDate)
            .startOf('day')
            .diff(moment(process.proccess.process_date).startOf('day'), 'days');

        const body = {
            _id: processId,
            order_id: process.order_id || null,
            date: destinationDate,
            order_process_start_date: destinationDate,
            order_process_end_date: moment(process.proccess.process_endDate)
                .add(diffDays, 'day')
                .toDate(),
            from: moment(this.state.currentDate).toDate(),
            to: moment(this.state.currentDate).add(28, 'days').toDate(),
            view: 'L',
            process: process.proccess,
            order_number: process.proccess.order_number,
            toBacklog: destination.droppableId === 'completions__droppable'
        };

        if (srcResource !== dstResource) {
            body.new_resource_id = dstResource;
            body.resources_added = [dstResource];
            body.resources_removed = [srcResource];
        }

        this.setState(
            {
                prevState: this.state.datesArray,
                updateApiBody: body,
                spreadingBodyData: body
            },
            async () => {
                this.setTransformDatesArray(datesArrayCopy);

                const endDate = body.order_process_end_date;
                if (
                    this.props.login.popupActivation &&
                    !body.process.constant &&
                    !body.process.is_detached &&
                    (isWeekChange(body.process.process_date, body.date) ||
                        isWeekChange(body.process.process_endDate, endDate))
                ) {
                    this.setState({ spreadingPopup: true, loader: false });
                    return;
                }

                const warningsApi = await getWarnings(body);
                if (!warningsApi.ok) {
                    this.setState({ popup: true, errPopupState: warningsApi.result, loader: false });
                    return;
                }

                if (warningsApi.result?.length) {
                    this.setState({ popup: true, warnings: warningsApi.result, loader: false });
                    return;
                }

                body.process.constant
                    ? this.props.updateConstantPopup(true)
                    : this.spreadingFalse();
            }
        );
    }

    async spreadingFalse() {
        this.setState({ loader: true, spreadingPopup: false })
        let body = { ...this.state.spreadingBodyData }
        let warningsApi = await getWarnings(body)

        if (warningsApi.ok) {
            if (warningsApi.result.length > 0) {
                this.setState({ popup: true, loader: false, warnings: warningsApi.result, spreadingPopup: false })
            } else {
                this.handlePopupChoice('yes')
            }
        } else {
            this.setState({ popup: true, loader: false, errPopupState: warningsApi.result, spreadingPopup: false })
        }
    }

    async spreadingTrue() {
        this.setState({ spreadingPopup: false })
        const { spreadingBodyData } = this.state
        let warningsApi = await getWarnings(spreadingBodyData, true)

        if (warningsApi.ok) {
            if (warningsApi?.result?.length > 0) {
                this.setState({ popup: true, loader: false, warnings: warningsApi.result })
            } else {
                this.setState({ spreading: true }, () => {
                    this.handlePopupChoice('yes', false)
                })
            }
        } else {
            this.setState({ popup: true, loader: false, errPopupState: warningsApi.result })
        }
    }

    closeUpdateMenu() {
        this.setState({
            updateProcessPopup: false,
            selectedProcess: {},
        })
    }

    async submitUpdatesFromPopup(body, constant, refetchData, newProcess = null) {
        if (moment(body.date).isSame(moment(body.process.process_date)) && !body.endDate) {
            this.setState({ updateProcessPopup: false }, () => this.initializeData())
            return
        }

        const { end_dateChanged } = body
        if (end_dateChanged) delete body.end_dateChanged

        let diff = moment(moment(body.date).set({ hour: 14, minute: 0, second: 0 }).toDate()).diff(moment(body.process.process_date).set({ hour: 14, minute: 0, second: 0 }).toDate(), 'days')
        let end_date = moment(body.process.process_endDate).set({ hour: 14, minute: 0, second: 0 }).add(diff, 'day').toDate()

        this.setState({
            spreadingBodyData: body,
            updateApiBody: body,
            updateProcessPopup: false,
            end_dateChanged
        }, async () => {
            if (body.process.constant) {
                let warningRes = await getWarnings(body)
                if (warningRes.ok && warningRes.result.length <= 0) {
                    this.handlePopupChoice('yes')
                } else {
                    this.setState({ errPopupState: warningRes.result, popup: true })
                }
            } else {
                if (body.endDate && !body?.process?.is_detached && isWeekChange(body?.process?.process_endDate, body.endDate) ||
                    isWeekChange(body.process.process_endDate, end_date, diff > 0 ? 1 : -1)) {
                    this.setState({ spreadingPopup: true })
                } else {
                    this.spreadingFalse()
                }
            }
        })
    }

    initProccessUpdatePopup(data, date) {
        const new_process_id = data.proccess._id.match(/^[^_]+/)[0]
        const updatedData = {
            ...data,
            proccess: {
                ...data.proccess,
                _id: new_process_id
            }
        }

        this.setState({
            selectedProcess: updatedData,
            updateProcessPopup: true
        })
    }

    saveNewSelectedProcess(process) {
        this.setState(prevState => ({
            selectedProcess: {
                ...prevState.selectedProcess,
                proccess: { ...process }
            }
        }))
    }

    cancleSpreading() {
        const prevState = this.state.prevState.length > 0
            ? JSON.parse(JSON.stringify(this.state.prevState))
            : this.state.datesArray

        if (prevState.length > 0) {
            this.setTransformDatesArray(prevState)
        }
        this.setState({ spreadingPopup: false })
        this.props.updateConstantPopup(false)
    }

    backToToday() {
        this.setState({ orders: [], loader: true })
        const dynamicFactoryName = this.props.login.user.factory_name
        let search = window.location.search
        this.props.history.push(`/${dynamicFactoryName}/monthly-resources/${moment().toDate()}${search || ''}`)
        this.setState({ currentDate: moment().startOf('week') }, () => {
            this.initializeData()
        })
    }

    onBeforeCapture({ draggableId }) {
        let drag_id = draggableId.split('_')[0]
        let drag_element = document.getElementById(`${drag_id}x1y2`)
        let width = drag_element?.style?.width.split('')

        if (width && Number(width[width.length - 2]) > 1) {
            width[width.length - 2] = 1
            drag_element.style.width = width.join('')
            this.updateOpacity(1, drag_id)
        }
    }

    updateOpacity = (opacity, draggableId) => {
        let drag_element = document.getElementById(`${draggableId}x1y2`)
        let class_name = drag_element?.classList

        if (!class_name) return

        class_name = class_name[class_name.length - 1]
        if (!class_name.includes('xix')) class_name = class_name + 'xix'

        let class_element = [...document.getElementsByClassName(class_name)]

        if (class_element.length > 0) {
            class_element.forEach(item => {
                item.style.opacity = opacity
            })
        }
    }

    render() {
        const {
            currentDate,
            datesArray,
            popup,
            errPopupState,
            updateProcessPopup,
            selectedProcess,
            loader,
            warnings,
            spreadingPopup,
            simpleDateArray,
            z_index
        } = this.state

        const { off_days, holidays } = this.props.login.user
        const disableDrag = this.props.login?.user?.privileges?.includes(PER_USER) || false
        const dynamicFactoryName = this.props.login.user.factory_name
        const user_or_order_type = this.props.login.user.select_order_process_color_by

        return (
            <>
                <div className="month-view-page">
                    {spreadingPopup && (
                        <SpreadingPopup
                            spreadingFalse={this.spreadingFalse}
                            spreadingTrue={this.spreadingTrue}
                            cancleSpreading={this.cancleSpreading}
                        />
                    )}

                    {updateProcessPopup && (
                        <UpdateProccessPopup
                            warningApiPayload={this.state.updateApiBody}
                            selectedProcess={selectedProcess}
                            view={'L'}
                            closeUpdateMenu={this.closeUpdateMenu}
                            submitUpdatesFromPopup={this.submitUpdatesFromPopup}
                            offDays={off_days}
                            holidays={holidays}
                            saveNewSelectedProcess={this.saveNewSelectedProcess}
                            deleteBacklogsDuplications={this.deleteBacklogsDuplications}
                        />
                    )}

                    {popup && (
                        <OnDragPopup
                            afterConfirmationError={errPopupState}
                            popupActionHandler={this.handlePopupChoice}
                            warningApiPayload={this.state.updateApiBody}
                            warnings={warnings}
                        />
                    )}

                    {this.props.orders.constant_popup && (
                        <ConstantPopup
                            updateConstantToSpred={this.updateConstantToSpred}
                            spreadingFalse={this.spreadingFalse}
                            spreadingTrue={this.spreadingTrue}
                            cancleSpreading={this.cancleSpreading}
                            popupActionHandler={this.handlePopupChoice}
                        />
                    )}

                    {/* FIX: onDragEnd and onBeforeCapture are now bound in the constructor,
                        so DragDropContext receives stable function references and won't
                        force its subtree to re-render on every parent state change. */}
                    <DragDropContext
                        onDragEnd={this.onDragEnd}
                        onBeforeCapture={this.onBeforeCapture}
                    >
                        <Calendar
                            initProccessUpdatePopup={this.initProccessUpdatePopup}
                            datesArray={datesArray}
                            checkIfSameDay={this.checkIfSameDay}
                            currentSelectedDate={currentDate}
                            buildDatesArray={this.buildDatesArray}
                            fourWeeksDateChange={this.fourWeeksDateChange}
                            loader={loader}
                            daysOffNumber={off_days?.length || 0}
                            daysOff={off_days}
                            disableDrag={disableDrag}
                            backToToday={this.backToToday}
                            isCurrentProcess={this.props.process.show_first_uncomplete_process}
                            factoryName={dynamicFactoryName}
                            simpleDateArray={simpleDateArray}
                            z_index={z_index}
                            user_or_order_type={user_or_order_type}
                        />
                    </DragDropContext>
                </div>
                {loader && <LoaderNew />}
            </>
        )
    }
}

function mapStateToProps({ login, process, orders, mainPopup, monthResource }) {
    return { login, process, orders, mainPopup, monthResource }
}

export default withRouter(connect(mapStateToProps, actions)(MonthlyResourceView))